/**
 * Thẻ đạo cụ — loại (category, bảng đóng kiểu TopView, đợt 260922 E4-P2). Logic THUẦN, không import antd
 * để jest chạy được (App.test.tsx đã fail sẵn vì antd v6 + react-router-dom v7 không load được dưới jest).
 *
 * `PROP_CATEGORY_OPTIONS` là BẢN SAO tay của `PROP_CATEGORIES` (`admin-service/src/utils/filmPropDescribe.ts`) —
 * hai repo git riêng, không import chung được. Sửa một bên nhớ sửa bên kia (test `PROP_CATEGORY_OPTIONS` bắt
 * được lệch số lượng/thứ tự, không bắt được lệch NỘI DUNG chữ nếu ai gõ sai cả hai chỗ giống nhau).
 */
export const PROP_CATEGORY_OPTIONS = [
  'Weapon', 'Jewelry', 'Document', 'Device', 'Container', 'Tool', 'Vehicle',
  'Food & drink', 'Furniture', 'Accessory', 'Other',
] as const;

export type PropCategoryOption = (typeof PROP_CATEGORY_OPTIONS)[number];

const LABELS: Record<PropCategoryOption, string> = {
  Weapon: 'Vũ khí',
  Jewelry: 'Trang sức',
  Document: 'Giấy tờ',
  Device: 'Thiết bị',
  Container: 'Đồ chứa',
  Tool: 'Dụng cụ',
  Vehicle: 'Phương tiện',
  'Food & drink': 'Đồ ăn uống',
  Furniture: 'Nội thất',
  Accessory: 'Phụ kiện',
  Other: 'Khác',
};

/** Nhãn tiếng Việt cho chip loại — `null`/rỗng/không nhận ra ⇒ "Chưa phân loại". */
export function categoryLabel(cat: string | null | undefined): string {
  return LABELS[(cat || '') as PropCategoryOption] || 'Chưa phân loại';
}

/**
 * Gộp một tên vào danh sách tên phụ của `target` (260922 E4-P3 — nút "Gộp vào «X»" trên khối ứng viên).
 *
 * Chỉ để GỬI ĐI (`updateProp({ aliases })`) — backend (`cleanPropAliases`/`aliasConflicts`) vẫn là nơi chặn
 * cuối cùng (400 nếu trùng đạo cụ khác). Ở đây chỉ tránh vẽ chip trùng ngay trên màn hình trước khi gửi.
 *
 * 🔴 Gộp LIÊN TIẾP hai ứng viên vào cùng `target` không được làm mất tên gộp trước (phản biện lượt 1 blocker):
 * `target` phải là bản state MỚI NHẤT (đã có tên vừa gộp lần trước), không phải bản `bankMatch` cũ trong
 * response `prop-candidates` đã lỗi thời — trách nhiệm lấy đúng bản mới nhất thuộc về nơi GỌI hàm này.
 */
export function mergeAliasList(target: { name: string; aliases?: string[] }, extra: string): string[] {
  const clean = String(extra || '').trim();
  const current = target.aliases || [];
  if (!clean) return current;
  const norm = (s: string) => s.trim().toLowerCase();
  if (norm(clean) === norm(target.name)) return current; // trùng TÊN CHÍNH ⇒ không thêm
  if (current.some((a) => norm(a) === norm(clean))) return current; // trùng hoa thường ⇒ không nhân đôi
  return [...current, clean];
}
